import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

import ThankUserList from "./thank_user_list";

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    circleId: PropTypes.number.isRequired,
  },
  getInitialState() {
    return {
      circleThankUserCounts: [],
      userAvatarUrls: {},
    };
  },
  componentDidMount() {
    this.loadThankUserListFromServer();
  },
  loadThankUserListFromServer() {
    $.ajax({
      type: "GET",
      url: "/api/thank/circle_thank_user_list",
      cache: false,
      data: {
        circle_id: this.props.circleId,
      },
    })
      .done(
        function(data) {
          this.setState({
            circleThankUserCounts: data.circleThankUserCounts,
            userAvatarUrls: data.userAvatarUrls,
          });
        }.bind(this)
      )
      .fail(function() {}.bind(this));
  },
  render() {
    return (
      <ThankUserList
        circleThankUserCounts={this.state.circleThankUserCounts}
        userAvatarUrls={this.state.userAvatarUrls}
      />
    );
  },
});
